'use strict';
import * as T from 'prop-types';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/pluck';
import fuse from '../../../_libs/redux-fusion';
import {stateGoBack} from '../../../app/actions';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {settingsStates} from '../../router';
import {SettingsViewUploadsHeaderView} from './SettingsViewUploadsHeaderView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const onGoBack = () => dispatch(stateGoBack({state: settingsStates.settings}));

  const breadcrumbPath$ = props$
    .pluck('settingsTitle')
    .distinctUntilChanged()
    .map(label => [{
      id: 'settings',
      label,
      to: settingsStates.settings,
    }]);

  return props$
    .combineLatest(
      breadcrumbPath$,
      (props, breadcrumbPath) => ({
        ...props,
        breadcrumbPath,
        onGoBack,
      }));
};

const StreamedComponentContainer = fuse(StreamedComponent)(SettingsViewUploadsHeaderView);

// Wrap Container with I18nComponent so that we can get a translation prop
export const SettingsViewUploadsHeaderContainer = I18nComponent(StreamedComponentContainer, [
  {code: 'app.settings.header.label', prop: 'settingsTitle'},
  {code: 'app.settings.file.uploads.pending.header.label', prop: 'viewTitle'},
  {code: 'app.settings.file.uploads.pending.buttons.retry.label', prop: 'retryLabel'},
]);

// Required for legacy angular inter-op
SettingsViewUploadsHeaderContainer.propTypes = {
  onClickRetry: T.func,
};



// WEBPACK FOOTER //
// ./src/js/settings/components/SettingsViewUploadsHeader/SettingsViewUploadsHeaderContainer.js